export const RATE_TYPE_LABELS = {
  youtube: "YouTube",
  hfa: "HFA",
  asa: "HFA ASA",
  mri: "MRI",
  mlc: "The MLC",
  bmi: "BMI",
  sync: "Sync",
  cmrra: "CMRRA",
  ascap: "ASCAP",
  sesac: "SESAC",
  fuga: "FUGA",
  lyricfind: "LyricFind",
  subpublishing: "Sub-Publishing",
  subpublishingsync: "Sub-Publishing Sync",
  sub_publishing_sync: "Sub-Publishing Sync",
  soundexchange: "SoundExchange",
  sound_exchange: "SoundExchange",
  "record-distribution": "Record Distribution",
  record_distribution: "Record Distribution",
  "direct-licensing": "Direct License",
  direct_license: "Direct License",
  red_music_composition: "Red Music Composition",
  red_non_music_composition: "Red Non Music Composition",
  ad_performance_composition: "Ad Performance Composition",
  brazil_non_music: "Brazil Non Music",
  mechanical_royalties: "Mechanical Royalties",
};

const INCLUDED_RATE_TYPES = [
  "youtube",
  "hfa",
  "asa",
  "mri",
  "mlc",
  "bmi",
  "sync",
  "cmrra",
  "ascap",
  "sesac",
  "fuga",
  "lyricfind",
  "subpublishing",
  "subpublishingsync",
  // "subpublishingsync",
  "soundexchange",
  "sound_exchange",
  "record-distribution",
  "record_distribution",
  "direct-licensing",
  "direct_license",
  "mechanical_royalties",
];

export const RATE_TYPE_OPTIONS = [
  ...new Map(
    INCLUDED_RATE_TYPES.map((key) => [
      RATE_TYPE_LABELS[key],
      { value: key, label: RATE_TYPE_LABELS[key] },
    ]),
  ).values(),
];
